export default {
    ...process.env,
};
